import { colorConstants } from 'config/colorConstants';

export const TrendArrowDown = ({ className = '', color = colorConstants.red }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={className}>
        <path d="M7.99999 3.33325V12.6666M7.99999 12.6666L12.6667 7.99992M7.99999 12.6666L3.33333 7.99992" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);
